module.exports = __webpack_public_path__ + "img/trip_04.c6041a36.jpg";